import { useEffect } from 'react';

// Store
import { useDispatch } from 'react-redux';
import { fetchReceivedTodayCount } from 'store/slices/ordersSlice';

// Utils
import { supabase } from 'utils/supabase-client';

// Keeps the "today's received orders" count in sync via realtime so the
// sidebar badge updates when a new order comes in or its status changes.
const useReceivedTodayCount = (restaurantId) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!restaurantId) return () => {};

    dispatch(fetchReceivedTodayCount(restaurantId));

    const channel = supabase
      .channel(`received-today-count-${restaurantId}`)
      .on(
        'postgres_changes',
        {
          event: '*',
          filter: `restaurant_id=eq.${restaurantId}`,
          schema: 'public',
          table: 'orders'
        },
        () => {
          dispatch(fetchReceivedTodayCount(restaurantId));
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [dispatch, restaurantId]);
};

export default useReceivedTodayCount;
